export default {
  namespaced: true,
  billing_finance: {
    title: "Finanzas",
    month: "Mes",
    year: "Año",
    region: "Región",
    state: "Estado",
    rems: "REMS (Instalación)",
    security_company: "Empresa de seguridad",
    job_description: "Descripción del puesto",
    number_of_services: "Número de servicios",
    service_days: "Días de servicio",
    hours: "Horas",
    cost_per_shift: "Costo por turno",
    type_of_guard: "Tipo de guardia",
    work_schedule: "Jornada",
    save_successfully: "Guardado con éxito",
    delete_many: "Eliminar registros",
    delete: "Eliminar registros",
    delete_question: "¿Está seguro que desea eliminar los registros filtrados?",
    delete_description: " registros serán eliminados.",
  }
}